export default "__VITE_ASSET__kHLF$w5X__ 400w, __VITE_ASSET__Dd2Xx_eX__ 800w, __VITE_ASSET__CbrQ_WY___ 1024w";